{
  "markread": "merkitse luetuiksi",
  "newest": "uusimmat",
  "unread": "lukemattomat",
  "starred": "t&auml;hdelliset",
  "tags": "Avainsanat",
  "alltags": "kaikki avainsanat",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 tunti},other {# tuntia}} sitten",
  "minutes": "{0,plural,one {1 minuutti},other {# minuuttia}} sitten",
  "seconds": "{0,plural,one {1 sekunti},other {# sekuntia}} sitten",
  "star": "t&auml;hti",
  "unstar": "t&auml;hti pois",
  "mark": "luetuksi",
  "unmark": "lukemattomaksi",
  "load_img": "lataa kuvat",
  "open_window": "avaa",
  "searchbutton": "etsi",
  "sources": "L&auml;hteet",
  "source_add": "lis&auml;&auml; l&auml;hde",
  "source_opml": "tai tuo opml-tiedosto tai google reader",
  "source_export": "vie l&auml;hteet",
  "source_edit": "muokkaa",
  "source_delete": "poista",
  "source_warn": "Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?",
  "source_new": "uusi tallentamaton l&auml;hde",
  "source_title": "Nimi",
  "source_tags": "Avainsanat",
  "source_comma": "avainsanat erotetaan pilkulla",
  "source_select": "valitse l&auml;hde",
  "source_type": "Tyyppi",
  "source_save": "tallenna",
  "source_cancel": "peruuta",
  "source_saved": "tallennettu",
  "no_entries": "merkint&ouml;j&auml; ei l&ouml;ydetty",
  "more": "lis&auml;&auml;",
  "login": "kirjaudu sis&auml;&auml;n",
  "login_username": "k&auml;ytt&auml;j&auml;tunnus",
  "login_password": "salasana",
  "no_title": "ei otsikkoa",
  "error_share_native_abort": "Kohteen jakaminen epäonnistui – joko jakamiskohteita ei ole tai peruutat sen.",
  "close_entry": "Sulje",
  "login_invalid_credentials": "Väärä käyttäjänimi/salasana",
  "share_mail_label": "Jaa sähköpostitse",
  "sources_refreshed": "Lähteet virkistetty",
  "error_refreshing_source": "Lähteitä ei voi virkistää:",
  "source_refresh": "Virkistä tämä lähde",
  "refreshbutton": "Virkistä lähteet"
}
